import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const ElectricityMeter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-275v-30h245v-435c0-24.81-20.19-45-45-45h-435v230h-30v-260h465c41.36 0 75 33.65 75 75z' />
    <path d='m120 360h30v90h-30z' />
    <path d='m330 660h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m480 570h-150s0-30 0-30h120c16.57 0 30 13.43 30 30z' />
    <path d='m480 510h-150s0-30 0-30h120c16.57 0 30 13.43 30 30z' />
    <path d='m570 420h-360v-210h305c30.33 0 55 24.67 55 55zm-330-30h300v-125c0-13.79-11.21-25-25-25h-275z' />
    <circle cx='90' cy='690' r='30' />
    <path d='m210 720h-30c0-66.17-53.83-120-120-120v-30c82.71 0 150 67.29 150 150z' />
    <path d='m300 720h-30c0-115.79-94.21-210-210-210v-30c64.11 0 124.38 24.96 169.71 70.29s70.29 105.6 70.29 169.71z' />
  </IconBase>
));

ElectricityMeter.displayName = 'ElectricityMeter';

export default ElectricityMeter;
